import styled from "styled-components";
import frankimmo from "../../../images/LOGO.jpeg";
import immowelt from "../../../images/immowelt.jpeg";
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import bronzelogo from "../../../images/bronze_logo.svg";

const StyledLink = styled(Link)`
    text-decoration: none;
    margin: 0 15px;
    color: black;
`;

const Background = styled.footer`
    display: flex;
    justify-content: center;
    background-color: #f5f5f5;
    width: 100%;
    padding: 50px 0px;

`;

const Div = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 90%;
`;

const Header2 = styled.h2`
    margin-bottom: 30px;
    font-size: 35px;
`;

const StyledP = styled.p`
    margin: 10px 0;
    // color: white;
`;

const Weiteres = styled.div`
    margin-top: 40px;
`;

const LogoDiv = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 50px;
`;

const Logo = styled.img`
    height: 100px;
    margin: 10px 10px;
`;

const LogoBronze = styled.img`
    height: 120px;
    margin: 0px;

`;



function Footer() {
    return (
        <Background>
            <Div>
                <Header2>frank immobilien</Header2>
                <StyledP>Petra Frank</StyledP>
                <StyledP><FontAwesomeIcon icon={faPhone} />&nbsp;&nbsp;&nbsp;+49 8851 9400434</StyledP>
                <StyledP><FontAwesomeIcon icon={faEnvelope} />&nbsp;&nbsp;&nbsp;info@frank-immobilien.net</StyledP>
                <StyledP><FontAwesomeIcon icon={faLocationDot} />&nbsp;&nbsp;&nbsp;Rothenberg Nord 5, 82431 Kochel am See</StyledP>
                <LogoDiv>
                    <Logo src={frankimmo} alt="frankimmo" />
                    <Logo src={immowelt} alt="immowelt" />
                    <LogoBronze src={bronzelogo} alt="bronzelogo" />
                </LogoDiv>
                {/* <>Datenschutzerklärung</> */}
                <Weiteres>
                    <StyledLink to="/datenschutz">
                        Datenschutzerklärung
                    </StyledLink>

                    <StyledLink to="/impressum">
                        Impressum
                    </StyledLink>

                    <StyledLink to="/widerruf">
                        Widerruf
                    </StyledLink>
                </Weiteres>
            </Div>
        </Background>
    )
}

export default Footer;